export const ImageData = window.ImageData;
export const Asset = {};
